__turbopack_context__.v({
  "background-graphics": "hero-section-content-wrapper-module-scss-module__pT_1RG__background-graphics",
  "content": "hero-section-content-wrapper-module-scss-module__pT_1RG__content",
  "hero-section-content-wrapper": "hero-section-content-wrapper-module-scss-module__pT_1RG__hero-section-content-wrapper",
});
